import { CommonModule } from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrl: './radio.component.scss',
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class RadioComponent {

    @Input() checked = false;
    @Input() label = '';
    @Output() onClick = new EventEmitter<boolean>();

    handleClick() {
        this.onClick.emit(true);
    }
}
